/*
const initialState = { 
    checkboxes: [
        {
            id: 0, 
            name: 0, 
            isChecked: false, 
        },
    ]
}*/
const initialState = { 
    checkboxes: []
}

const graphFieldsReducer = (state = initialState, action) => {
    switch(action.type) {
        case 'UPDATE_GRAPH_FIELDS':
            return {
                ...state,  //append to current redux state
                checkboxes: [...state.checkboxes, action.payload] //input payload to redux state
            }

        case 'CLEAR_GRAPH_FIELDS':
            return {
                ...state,  //append to current redux state
                checkboxes: [] //input payload to redux state
            }
            
        case 'UPDATE_GRAPH_FIELD_CHECKBOX':
            //console.log('*** Checkbox: ', action.payload.id, ' - ', action.payload.name, ' - ', action.payload.isChecked);
            return {
                ...state,  //append to current redux state
                checkboxes: state.checkboxes.map(checkbox => checkbox.id === action.payload.id ?
                    {...checkbox, isChecked: !action.payload.isChecked} : checkbox
                )
            }
        
        case 'UNCHECK_ALL_GRAPH_FIELD_CHECKBOXS':
            //console.log('*** Checkbox >>> call uncheck all... ');
            return {
                ...state,  //append to current redux state
                checkboxes: state.checkboxes.map((checkbox, index) => checkbox.id === index ?
                    {...checkbox, isChecked: false} : checkbox
                )
            }
        
        case 'CHECK_ALL_GRAPH_FIELD_CHECKBOXS':
            //console.log('*** Checkbox >>> call uncheck all... ');
            return {
                ...state,  //append to current redux state
                checkboxes: state.checkboxes.map((checkbox, index) => checkbox.id === index ?
                    {...checkbox, isChecked: true} : checkbox
                )
            }
    
            default:
                return state;
    }
} 
export default graphFieldsReducer;
